import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { appVersion } from '../project/Layout/version';
import { Container } from 'lucide-react';

const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 70px 20px;
  position: relative;
  z-index: 2;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 40px;
`;

const Title = styled.h1`
  color: #f29f02;
  font-size: 2.8rem;
  margin-bottom: 10px;
`;

const Subtitle = styled.p`
  font-size: 1.3rem;
  color: #333;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 25px;
`;

const Card = styled.div`
  background: rgba(255,255,255, 0.5);
  border-radius: 15px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
  padding: 25px;
  text-align: center;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-5px);
  }
`;

const CardTitle = styled.h2`
  color: #f29f02;
  font-size: 1.5rem;
  margin: 15px 0 10px;
`;

const CardDesc = styled.p`
  font-size: 1rem;
  color: #444;
  text-align: justify;
`;

const Icon = styled.img`
  width: 80px;
  height: 80px;
`;

const float = keyframes`
  0% { transform: translateY(0) translateX(0); opacity: 0.8; }
  50% { transform: translateY(-20px) translateX(10px); opacity: 0.4; }
  100% { transform: translateY(0) translateX(0); opacity: 0.8; }
`;
        
const FloatingIcon = styled.img`
  position: absolute;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  width: ${(props) => props.size};
  animation: ${float} ${(props) => props.duration} ease-in-out infinite;
  pointer-events: none;
  opacity: 0.6;
  z-index: 1;
`;

const BGWrapper = styled.div`
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  background: linear-gradient(135deg, #f7f7f7, #e2ecf4);
`;

const Service = () => {
  const services = [
    { img: 'assets/service/consultant.gif', title: 'IT Consultant', description: 'Helping businesses leverage technology to reach strategic goals.' },
    { img: 'assets/service/globe.gif', title: 'Web Development', description: 'Designing and building modern, responsive websites.' },
    { img: 'assets/service/play.gif', title: 'Mobile Development', description: 'Creating user-friendly mobile apps for Android and iOS.' },
  ];

  return (
    <BGWrapper>
      <Wrapper>
        <Header>
          <Title style={{color:'black'}}>Our Services</Title>
          <Subtitle  style={{color:'#360185'}}>We offer professional digital solutions for your business.</Subtitle>
        </Header>
        <Grid>
          {services.map((service, index) => (
            <Card key={index}>
              <Icon src={service.img} alt={service.title} />
              <CardTitle>{service.title}</CardTitle>
              <CardDesc>{service.description}</CardDesc>
            </Card>
          ))}
        </Grid>
      </Wrapper>      
    </BGWrapper>
  );
};

export default Service;